import React from "react";
import { Box, Card, CardContent, Typography } from "@mui/material";
import { PieChart, Pie, Cell, Tooltip } from "recharts";
import { formatCurrency } from "../../../utils/utils";

interface MetricData {
  value: number;
  label: string;
  color: string;
}

interface ReportPieProps {
  data: MetricData[];
}

const ReportPie: React.FC<ReportPieProps> = ({ data }) => {
  const CustomTooltip = ({ active, payload }: any) => {
    if (active && payload && payload.length) {
      return (
        <Box
          sx={{
            backgroundColor: "background.paper",
            p: 1,
            border: "1px solid",
            borderColor: "divider",
            borderRadius: 1,
          }}
        >
          <Typography
            variant="body2"
            color="text.primary"
            sx={{ fontSize: "12px" }}
          >
            {payload[0].payload.label}
          </Typography>
          <Typography
            variant="body2"
            color="text.secondary"
            sx={{ fontSize: "12px" }}
          >
            {formatCurrency(payload[0].value)}
          </Typography>
        </Box>
      );
    }
    return null;
  };

  return (
    <Card>
      <CardContent>
        <Box display="flex" justifyContent="space-between">
          {/* Left Column - Content */}
          <Box display="flex" flexDirection="column" gap={2} flex={1}>
            {/* Legends */}
            <Box display="flex" flexDirection="column" gap={1}>
              {data.map((item, index) => (
                <Box key={index} display="flex" alignItems="center">
                  <Box
                    width={12}
                    height={12}
                    borderRadius="50%"
                    bgcolor={item.color}
                    mr={1}
                  />
                  <Typography
                    variant="body2"
                    color="text.secondary"
                    sx={{ fontSize: "12px" }}
                  >
                    {item.label} ({formatCurrency(item.value)})
                  </Typography>
                </Box>
              ))}
            </Box>
          </Box>

          {/* Right Column - Chart */}
          <Box display="flex" alignItems="center" pl={2}>
            <PieChart width={160} height={160}>
              <Pie
                data={data}
                cx={80}
                cy={80}
                innerRadius={45}
                outerRadius={70}
                paddingAngle={2}
                dataKey="value"
              >
                {data.map((entry, index) => (
                  <Cell key={`cell-${index}`} fill={entry.color} />
                ))}
              </Pie>
              <Tooltip
                content={<CustomTooltip />}
                wrapperStyle={{ outline: "none" }}
              />
            </PieChart>
          </Box>
        </Box>
      </CardContent>
    </Card>
  );
};

export default ReportPie;
